export enum ProductTourType {
  Main = 'main',
  Database = 'database',
  Document = 'document',
}
